/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';

import insideLogin from '../../cra/src/components/menuBar/insideLogin';
import Toolbar from '../components/Toolbar';
import { getUniversityServicesRestrictions } from '../../cra/src/utility/universityRestrictions';
import { UNIVERSITYPLAN } from '../../cra/src/utility/enums/planType';
import route from '../../cra/src/constants/route';
import CommonHigherMobileToolbar from '../../cra/src/components/userDocuments/editDocument/editResume/Toolbar/RightToolbar/higherMobileToolbar';

class MenuBar extends React.PureComponent {
  state = {
    isDropdownOpen: false,
    isTop: true,
    rightList: insideLogin.logoutRightList,
  };

  componentDidMount = () => {
    document.addEventListener('scroll', () => {
      const isTop = window.scrollY < 72;
      const { isTop: currentTop } = this.state;
      const { pathname } = this.props;
      if (
        pathname === '/' ||
        pathname === '/about-us' ||
        pathname === '/about-us/'
      ) {
        if (isTop !== currentTop) {
          this.setState({ isTop });
        }
      }
    });
    const rightList = this.getRightList();
    this.setState({ rightList });
  };

  componentDidUpdate = (prevProps) => {
    const { userInfoFetched: prevUserInfoFetched } = prevProps;
    const { userInfoFetched } = this.props;
    if (prevUserInfoFetched !== userInfoFetched) {
      const rightList = this.getRightList();
      this.setState({ rightList });
    }
  };

  getRightList = () => {
    const { userInfoFetched, selectedPlan, user, universityPlan } = this.props;
    let rightList;

    if (user.token) {
      const filterLoggedInList = insideLogin?.loggedInRightList.filter(
        (item) => {
          if (!userInfoFetched) {
            if (item.url === '/services' || item.url === route.INVITE)
              return null;
            if (item.url !== '/pricing') {
              return item;
            }
          }
          if (userInfoFetched && selectedPlan === UNIVERSITYPLAN) {
            const services = getUniversityServicesRestrictions(universityPlan);
            if (services?.iris && item.url === '/services') {
              return null;
            }
            if (item.url === '/pricing' || item.url === route.INVITE) {
              return null;
            }
            return item;
          }
          return null;
        },
      );

      const filterLoggedInListNonUnivMem =
        insideLogin?.loggedInRightList.filter((item) => {
          if (item.url !== '/services') {
            return item;
          }

          return null;
        });
      if (!userInfoFetched) {
        rightList = filterLoggedInList;
      } else if (selectedPlan !== UNIVERSITYPLAN) {
        rightList = filterLoggedInListNonUnivMem;
      } else {
        rightList = filterLoggedInList;
      }
    } else {
      rightList = insideLogin?.logoutRightList;
    }
    return rightList;
  };

  handleDropDown = (e) => {
    const { isDropdownOpen } = this.state;
    e.stopPropagation();
    if (window.screen.width >= 1024) {
      if (!isDropdownOpen) this.setState({ isDropdownOpen: true });
      if (isDropdownOpen) this.setState({ isDropdownOpen: false });
    }

    e.preventDefault();
  };

  sideDrawerClosedHandler = () => {
    this.setState({ showSideDrawer: false });
  };

  sideDrawerToggleHandler = () => {
    this.setState((prevState) => ({
      showSideDrawer: !prevState.showSideDrawer,
    }));
  };

  setDrawerState = (rightList, childrenList) => {
    this.setState({ rightList, childrenList });
  };

  render() {
    const {
      pathname,
      user,
      inviteId,
      appType,
      LinkComponent,
      HigherMobileToolbar = CommonHigherMobileToolbar,
      userInfoFetched,
      selectedPlan,
      universityPlan,
      ProfileIcon,
      Notifications,
      MobileToolbar,
      CommonToolbar,
      organizationIdentity,
    } = this.props;
    const { childrenList, showSideDrawer, isTop, rightList } = this.state;

    return (
      <>
        <Toolbar
          rightList={rightList}
          className="commonHeader"
          pathname={window.location.pathname}
          isTop={isTop}
          user={user}
          inviteId={inviteId}
          setDrawerState={this.setDrawerState}
          sideDrawerToggleHandler={this.sideDrawerToggleHandler}
          appType={appType}
          showSideDrawer={showSideDrawer}
          childrenList={childrenList}
          sideDrawerClosedHandler={this.sideDrawerClosedHandler}
          universityPlan={universityPlan}
          LinkComponent={LinkComponent}
          ProfileIcon={ProfileIcon}
          Notifications={Notifications}
          MobileToolbar={MobileToolbar}
          CommonToolbar={CommonToolbar}
          organizationIdentity={organizationIdentity}
        />
        {rightList && !pathname.includes('/documents/') && (
          <HigherMobileToolbar
            appType={appType}
            rightList={rightList}
            pathname={window.location.pathname}
            showSideDrawer={showSideDrawer}
            user={user.user}
            userInfo={user}
            sideDrawerClosedHandler={this.sideDrawerClosedHandler}
            childrenList={childrenList}
            inviteId={inviteId}
            userInfoFetched={userInfoFetched}
            selectedPlan={selectedPlan}
            universityPlan={universityPlan}
            LinkComponent={LinkComponent}
          />
        )}
      </>
    );
  }
}

MenuBar.propTypes = {
  inviteId: PropTypes.string,
  userInfo: PropTypes.shape({ userInfo: PropTypes.object }),
  webSocket: PropTypes.shape({ webSocket: PropTypes.object }),
  user: PropTypes.shape({ user: PropTypes.object }),
  pathname: PropTypes.string,
};

MenuBar.defaultProps = {
  userInfo: undefined,
  inviteId: '',
  webSocket: {},
  user: {},
  pathname: '',
};

export default MenuBar;
